// extracted by mini-css-extract-plugin
export default {"image":"Picture_image_b0614"};